import { Flex, Icon, Text, Badge, Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Color } from "theme/old-design-system/styled-components";
import { ReactComponent as FuzeyTarget } from "assets/icons/Fuzey_Logomark_Dark.svg";
import { ReactComponent as Calendar } from "assets/icons/gradient-calendar.svg";
import { ReactComponent as Envelope } from "assets/icons/rounded-gradient-envelope.svg";
import { ReactComponent as CreditCard } from "assets/icons/gradient-credit-card.svg";
import AutomationDomain from "entities/domain/automation";
import { useAuth0 } from "@auth0/auth0-react";
import { canSendPayments } from "util/permissions";
import useMerchantStore from "hooks/use-merchant-store";

interface AutomationCardProps {
  automation: AutomationDomain;
  onSelect: () => void;
}

export const ICON_BY_TEMPLATE_ID: {
  [key: string]: React.FunctionComponent;
} = {
  booking_reminder: Calendar,
  payment_reminder: CreditCard,
  auto_reply: Envelope,
};

const AutomationCard = ({ automation, onSelect }: AutomationCardProps) => {
  const [isEditable, setIsEditable] = useState<boolean>(true);

  const { merchant } = useMerchantStore();
  const { user } = useAuth0();

  useEffect(() => {
    if (automation.templateId === "payment_reminder") {
      setIsEditable(
        canSendPayments(user!.user_authorization.permissions, merchant)
      );
    }
  }, [user]);

  return (
    <Flex
      border="1px solid #E7EDF4"
      borderRadius="2xl"
      px="1rem"
      py={0}
      height="300px"
      width="320px"
      mb="2rem"
      flexDirection="column"
      onClick={isEditable ? onSelect : undefined}
      p="1rem"
      opacity={isEditable ? 1 : 0.5}
      _hover={{
        cursor: isEditable ? "pointer" : "not-allowed",
        boxShadow: `0 0 1rem ${Color.GREYISH_WHITE.value}`,
      }}
    >
      <Icon
        flexGrow={1}
        flexShrink={0}
        as={ICON_BY_TEMPLATE_ID[automation.templateId] || FuzeyTarget}
        __css={{ width: "40px" }}
      />
      <Text
        my="1rem"
        textAlign="center"
        fontWeight={600}
        fontSize="lg"
        flexGrow={2}
        flexShrink={0}
        textOverflow="ellipsis"
        overflow="hidden"
        maxHeight="30px"
      >
        {automation.name}
      </Text>
      <Text
        mb="1rem"
        textAlign="center"
        fontSize="md"
        flexShrink={0}
        flexGrow={2}
        textOverflow="ellipsis"
        overflow="hidden"
        maxHeight="100px"
      >
        {automation.description}
      </Text>
      <Box pt={3}>
        <Badge
          colorScheme={automation.enabled ? "green" : "red"}
          flexGrow={0}
          flexBasis={0}
        >
          {automation.enabled ? "Enabled" : "Disabled"}
        </Badge>
      </Box>
    </Flex>
  );
};

export default AutomationCard;
